import { AfterViewInit, Directive, inject } from '@angular/core';
import { IsActiveMatchOptions, RouterLinkActive } from '@angular/router';

const ExactMatchWithFragments: IsActiveMatchOptions = {
  paths: 'exact',
  fragment: 'exact',
  matrixParams: 'ignored',
  queryParams: 'exact',
};

@Directive({
  selector: '[routerLinkActive]:not([routerLinkActiveOptions])',
  standalone: true
})
export class RouterLinkDefaultMatchDirective implements AfterViewInit {

  private routerLinkActive = inject(RouterLinkActive);

  ngAfterViewInit() {
    // Only set default options if none are already provided
    this.routerLinkActive.routerLinkActiveOptions = ExactMatchWithFragments;
  }
}